import { Button } from '@chegg-ui/button';
import React, { useEffect } from 'react';
import config from "../../config";
import { emailFocus, flipView, setEmail, setEmailError, setPassword } from "../../store/reducer";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { PxCaptchaTypes, View } from "../../store/types";
import Header from "../Header";
import Message from "../Message";
import { Centered, EmailInput, FlipViewButton, Footer, InfoLink, SubmitButton } from "../shared.styles";
import { CheckEmailView, FooterParagraph, Form, Paragraph, ResetPasswordView, SmallerGapContainer, TopContainer } from "./ResetPassword.styles";
import { setGenericError, setLoading } from "../../store/sharedActions";
import { isValidEmail } from "../../utils/passwordValidations";
import { clickstreamViewEvent, interactionsRioEvent, notificationsRioEvent } from "../../lib/rio/rioEvents";
import { sdkResetPassword } from "../../store/reducers/sdkResetPassword";
import PxCaptcha from "../PxCaptcha";
import { getTexts } from "../../lib/contentful/defaultTexts";
import { NotificationTypes } from '@chegg-ui/notification-banner';
var ResetPassword = function ResetPassword(props) {
  var options = props.options,
    styles = props.styles;
  var env = useAppSelector(function (state) {
    return state.env;
  });
  var state = useAppSelector(function (state) {
    return state.resetPassword;
  });
  var showBack = useAppSelector(function (state) {
    return state.showBack;
  });
  var backView = useAppSelector(function (state) {
    return state.backView;
  });
  var frontView = useAppSelector(function (state) {
    return state.frontView;
  });
  var view = showBack && backView || frontView;
  var pxCaptchaType = useAppSelector(function (state) {
    return state.pxCaptchaType;
  });
  var _state$credentials = state.credentials,
    email = _state$credentials.email,
    error = _state$credentials.error,
    loading = state.loading,
    successScreen = state.successScreen;
  var dispatch = useAppDispatch();
  var value = email.value,
    valid = email.valid,
    focus = email.focus,
    changed = email.changed,
    touched = email.touched,
    emailError = email.error;
  var termsLink = config[env].termsOfUseLink;
  var privacyLink = config[env].privacyPolicyLink;
  var _getTexts = getTexts(),
    _getTexts$resetPasswo = _getTexts.resetPassword,
    resetPasswordSubmitButtonTitle = _getTexts$resetPasswo.resetPasswordSubmitButtonTitle,
    resetPasswordInvalidEmailError = _getTexts$resetPasswo.resetPasswordInvalidEmailError,
    resetPasswordText = _getTexts$resetPasswo.resetPasswordText,
    emaillabel = _getTexts$resetPasswo.emaillabel,
    emailInputPlaceholder = _getTexts$resetPasswo.emailInputPlaceholder,
    cancelText = _getTexts$resetPasswo.cancelText,
    emptyEmailError = _getTexts$resetPasswo.emptyEmailError,
    termsAgreeText = _getTexts$resetPasswo.termsAgreeText,
    terms = _getTexts$resetPasswo.terms,
    and = _getTexts$resetPasswo.and,
    privacyPolicy = _getTexts$resetPasswo.privacyPolicy,
    customerService = _getTexts$resetPasswo.customerService,
    checkYourEmail = _getTexts$resetPasswo.checkYourEmail,
    resetPassowrdInstructionsError = _getTexts$resetPasswo.resetPassowrdInstructionsError,
    gotItText = _getTexts$resetPasswo.gotItText,
    didntGetEmailText = _getTexts$resetPasswo.didntGetEmailText,
    checkJunkMailText = _getTexts$resetPasswo.checkJunkMailText;
  useEffect(function () {
    clickstreamViewEvent('reset password');
  }, []);
  useEffect(function () {
    if (!valid && !focus && touched && changed && !emailError && value.length) {
      dispatch(setEmailError({
        error: resetPasswordInvalidEmailError
      }));
      notificationsRioEvent({
        notifications: {
          type: 'error',
          message_name: 'reset password error',
          message_detail: resetPasswordInvalidEmailError,
          message_id: 'reset password: email invalid error'
        }
      });
    }
  }, [value, focus, valid, touched, changed, emailError, dispatch, resetPasswordInvalidEmailError]);
  if (successScreen) {
    return renderSuccessScreen();
  }
  return /*#__PURE__*/React.createElement(ResetPasswordView, {
    "data-test": "reset_password_view"
  }, /*#__PURE__*/React.createElement(Header, {
    styles: styles === null || styles === void 0 ? void 0 : styles.header,
    "data-test": "reset_password_",
    subTitle: options === null || options === void 0 ? void 0 : options.subtitle,
    title: (options === null || options === void 0 ? void 0 : options.title) || resetPasswordText
  }), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(SmallerGapContainer, null, /*#__PURE__*/React.createElement(EmailInput, {
    inputId: "reset_password_input",
    "data-test": "reset_password_input",
    value: value,
    labelText: emaillabel,
    onChange: onEmailChange,
    onBlur: onEmailBlur,
    onFocus: onEmailFocus,
    placeholder: emailInputPlaceholder,
    className: "reset_password_input",
    autoComplete: "email",
    errorText: emailError || undefined
  }), renderPxCaptcha(), renderMessage()), renderFooter(), /*#__PURE__*/React.createElement(SmallerGapContainer, null, /*#__PURE__*/React.createElement(SubmitButton, {
    "data-test": "reset_password_submit",
    type: "submit",
    size: 'medium',
    isLoading: loading,
    disabled: !valid
  }, (options === null || options === void 0 ? void 0 : options.buttonTitle) || resetPasswordSubmitButtonTitle), /*#__PURE__*/React.createElement(Centered, null, /*#__PURE__*/React.createElement(FlipViewButton, {
    "data-test": "reset_password_to_signin",
    onClick: onFlipView
  }, cancelText)))));
  function onSubmit(e) {
    e.preventDefault();
    if (!loading) {
      dispatch(sdkResetPassword());
      interactionsRioEvent({
        interaction: {
          type: 'click',
          element: {
            type: 'button',
            name: 'reset password',
            region_name: 'reset password page'
          }
        }
      });
    }
  }
  function onEmailChange(email) {
    dispatch(setEmail({
      email: email
    }));
  }
  function onFlipView() {
    if (error) {
      dispatch(setGenericError({
        error: ''
      }));
    }
    if (pxCaptchaType === PxCaptchaTypes.RESET_PASSWORD) {
      dispatch(setGenericError({
        error: '',
        onView: View.RESET_PASSWORD
      }));
      dispatch(setLoading({
        loading: false,
        onView: View.RESET_PASSWORD
      }));
    }
    dispatch(flipView({
      view: View.SIGNIN
    }));
    interactionsRioEvent({
      interaction: {
        type: 'cancel',
        element: {
          type: 'link',
          name: 'reset password request',
          region_name: 'reset password page'
        }
      }
    });
  }
  function onEmailBlur() {
    if (!value.length && changed) {
      dispatch(setEmailError({
        error: emptyEmailError
      }));
      notificationsRioEvent({
        notifications: {
          type: 'error',
          message_name: 'reset password error',
          message_detail: emptyEmailError,
          message_id: 'reset password: email empty error'
        }
      });
      return;
    } else if (!isValidEmail(value) && changed) {
      dispatch(setEmailError({
        error: resetPasswordInvalidEmailError
      }));
      notificationsRioEvent({
        notifications: {
          type: 'error',
          message_name: 'reset password error',
          message_detail: resetPasswordInvalidEmailError,
          message_id: 'reset password: email invalid error'
        }
      });
      return;
    }
  }
  function onEmailFocus() {
    dispatch(emailFocus());
  }
  function renderMessage() {
    if (error) {
      return /*#__PURE__*/React.createElement(Message, {
        type: NotificationTypes.Error,
        text: error
      });
    }
  }
  function renderFooter() {
    return /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement("p", {
      "data-test": "terms_of_use_info"
    }, termsAgreeText, ' ', /*#__PURE__*/React.createElement(InfoLink, {
      "data-test": "reset_password_terms_link",
      href: termsLink,
      onClick: onTermsOfUseClick,
      target: "_blank"
    }, terms), ' ', and, ' ', /*#__PURE__*/React.createElement(InfoLink, {
      "data-test": "reset_password_privacy_link",
      href: privacyLink,
      onClick: onPrivacyPolicyClick,
      target: "_blank"
    }, privacyPolicy)));
  }
  function renderSuccessScreen() {
    var _options$customerServ, _options$customerServ2, _options$customerServ3;
    var link = (options === null || options === void 0 ? void 0 : (_options$customerServ = options.customerServiceUrl) === null || _options$customerServ === void 0 ? void 0 : _options$customerServ.url) || config[env].customerServiceUrl;
    var text = (options === null || options === void 0 ? void 0 : (_options$customerServ2 = options.customerServiceUrl) === null || _options$customerServ2 === void 0 ? void 0 : _options$customerServ2.text) || customerService;
    var target = (options === null || options === void 0 ? void 0 : (_options$customerServ3 = options.customerServiceUrl) === null || _options$customerServ3 === void 0 ? void 0 : _options$customerServ3.newWindow) && '_blank' || '_self';
    return /*#__PURE__*/React.createElement("div", {
      "data-test": "reset_password_success"
    }, /*#__PURE__*/React.createElement(CheckEmailView, null, /*#__PURE__*/React.createElement(TopContainer, null, /*#__PURE__*/React.createElement(Header, {
      "data-test": "reset_password_",
      title: checkYourEmail
    }), /*#__PURE__*/React.createElement(Paragraph, null, resetPassowrdInstructionsError)), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement("b", {
      "data-test": "reset_password_success_email"
    }, " ", value)), /*#__PURE__*/React.createElement(Button, {
      "data-test": "reset_password_on_success",
      onClick: onSuccessClick,
      size: 'medium',
      type: "button"
    }, gotItText), /*#__PURE__*/React.createElement(FooterParagraph, null, /*#__PURE__*/React.createElement("span", null, didntGetEmailText, " "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, checkJunkMailText, " "), /*#__PURE__*/React.createElement(InfoLink, {
      href: link,
      target: target
    }, text), ".")));
  }
  function onSuccessClick() {
    dispatch(setPassword({
      password: '',
      onView: View.SIGNIN
    }));
    dispatch(setGenericError({
      error: '',
      onView: View.SIGNIN
    }));
    dispatch(flipView({
      view: View.SIGNIN
    }));
  }
  function onTermsOfUseClick() {
    interactionsRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'terms of use',
          region_name: 'reset password page',
          value: termsLink
        }
      }
    });
  }
  function onPrivacyPolicyClick() {
    interactionsRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'privacy policy',
          region_name: 'reset password page',
          value: privacyLink
        }
      }
    });
  }
  function renderPxCaptcha() {
    if (pxCaptchaType !== PxCaptchaTypes.RESET_PASSWORD || view !== View.RESET_PASSWORD) return null;
    return /*#__PURE__*/React.createElement(PxCaptcha, {
      dataTest: "px_captcha_resetpassword"
    });
  }
};
export default ResetPassword;